// Author liang gang qiang
// Date 2021-11-18 16:39:58

class MintalMesPrdShiftPlan {
constructor({
        id = null,
        prdMonthId = '',
        code = '',
        day = '',
        shiftId = '',
        shiftStartTime = '',
        shiftEndTime = '',
        output = '',
        operationRate = '',
        status = '',
        remark = ''}
= {}) {
    this.id = id;
    this.prdMonthId = prdMonthId;
    this.code = code;
    this.day = day;
    this.shiftId = shiftId;
    this.shiftStartTime = shiftStartTime;
    this.shiftEndTime = shiftEndTime;
    this.output = output;
    this.operationRate = operationRate;
    this.status = status;
    this.remark = remark;
}
}

function newEntity() {
return new MintalMesPrdShiftPlan();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.mintal.prd.mintalMesPrdShiftPlan.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'locationName',
        label: 'label.mintal.prd.mintalMesPrdShiftPlan.grid.locationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'materialName',
        label: 'label.mintal.prd.mintalMesPrdShiftPlan.grid.materialName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'code',
        label: 'label.mintal.prd.mintalMesPrdShiftPlan.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'day',
        label: 'label.mintal.prd.mintalMesPrdShiftPlan.grid.day',
        sortable: true,
        form: {
        type: 'datepicker'
        }
        },
        {
        key: 'shiftName',
        label: 'label.mintal.prd.mintalMesPrdShiftPlan.grid.shiftName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'shiftStartTime',
        label: 'label.mintal.prd.mintalMesPrdShiftPlan.grid.shiftStartTime',
        sortable: true,
        form: {
        type: 'hour_minute'
        }
        },
        {
        key: 'shiftEndTime',
        label: 'label.mintal.prd.mintalMesPrdShiftPlan.grid.shiftEndTime',
        sortable: true,
        form: {
        type: 'hour_minute'
        }
        },
        {
        key: 'output',
        label: 'label.mintal.prd.mintalMesPrdShiftPlan.grid.output',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'qualitySpe1',
        label: 'label.mintal.prd.mintalMesPrdShiftPlan.grid.qualitySpe1',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'qualitySpe2',
        label: 'label.mintal.prd.mintalMesPrdShiftPlan.grid.qualitySpe2',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdShiftPlan.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    prdMonthIdFilter : '',
    codeFilter : '',
    dayRteFilter : '',
    dayLteFilter : '',
    shiftIdFilter : '',
    shiftStartTimeRteFilter : '',
    shiftStartTimeLteFilter : '',
    shiftEndTimeRteFilter : '',
    shiftEndTimeLteFilter : '',
    outputFilter : '',
    operationRateFilter : '',
    statusFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'prdMonthIdFilter',
        label: 'label.mintal.prd.mintalMesPrdShiftPlan.filter.prdMonthId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesPrdMonthPlan'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'codeFilter',
        label: 'label.mintal.prd.mintalMesPrdShiftPlan.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'dayRteFilter',
        label: 'label.mintal.prd.mintalMesPrdShiftPlan.filter.dayRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'dayLteFilter',
        label: 'label.mintal.prd.mintalMesPrdShiftPlan.filter.dayLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'shiftIdFilter',
        label: 'label.mintal.prd.mintalMesPrdShiftPlan.filter.shiftId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'imfMstShift'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'shiftStartTimeRteFilter',
        label: 'label.mintal.prd.mintalMesPrdShiftPlan.filter.shiftStartTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'shiftStartTimeLteFilter',
        label: 'label.mintal.prd.mintalMesPrdShiftPlan.filter.shiftStartTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'shiftEndTimeRteFilter',
        label: 'label.mintal.prd.mintalMesPrdShiftPlan.filter.shiftEndTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'shiftEndTimeLteFilter',
        label: 'label.mintal.prd.mintalMesPrdShiftPlan.filter.shiftEndTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'outputFilter',
        label: 'label.mintal.prd.mintalMesPrdShiftPlan.filter.output',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'prdMonthId',
        label: 'label.mintal.prd.mintalMesPrdShiftPlan.entity.prdMonthId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesPrdMonthPlan'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'code',
        label: 'label.mintal.prd.mintalMesPrdShiftPlan.entity.code',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'day',
        label: 'label.mintal.prd.mintalMesPrdShiftPlan.entity.day',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'shiftId',
        label: 'label.mintal.prd.mintalMesPrdShiftPlan.entity.shiftId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'imfMstShift'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'output',
        label: 'label.mintal.prd.mintalMesPrdShiftPlan.entity.output',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdShiftPlan.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {MintalMesPrdShiftPlan, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
